export default "__VITE_ASSET__C860E4Kp__"